export const SchemaFormRenderErrors = {
    invalidSchema: new Error("Invalid schema"),
    noElementSchema: new Error("No element schema provided"),
    unknownFormElement: new Error("Unknown form element"),
};
